module.exports = __webpack_public_path__ + "img/download.c7c6b982.svg";